import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AdminAgioFacade } from './admin-agio.facade';
import {
  AgioOverrides,
  AgioOverridesUpdateDto,
  AgioSettings,
  AgioSettingsUpdateDto,
  EffectiveAgioSettings,
} from '@models/resources/agio.model';
import { environment } from '../../../../environments/environment';

@Injectable()
export class HttpAdminAgioFacade implements AdminAgioFacade {
  private readonly http = inject(HttpClient);
  private readonly base = environment.apiUrl;

  getSettings(): Observable<AgioSettings> {
    return this.http.get<AgioSettings>(`${this.base}/agio/settings`);
  }

  saveSettings(dto: AgioSettingsUpdateDto): Observable<AgioSettings> {
    return this.http.patch<AgioSettings>(`${this.base}/agio/settings`, dto);
  }

  getOverrides(customerId: number): Observable<AgioOverrides> {
    return this.http.get<AgioOverrides>(`${this.base}/customers/${customerId}/agio-overrides`);
  }

  saveOverrides(customerId: number, dto: AgioOverridesUpdateDto): Observable<AgioOverrides> {
    return this.http.patch<AgioOverrides>(
      `${this.base}/customers/${customerId}/agio-overrides`,
      dto,
    );
  }

  getEffective(customerId: number): Observable<EffectiveAgioSettings> {
    return this.http.get<EffectiveAgioSettings>(
      `${this.base}/customers/${customerId}/agio-overrides/effective`,
    );
  }
}
